module.exports = __webpack_public_path__ + "img/painting_cn.637080f.jpg";